import "./Footer.scss";
import { useState, useEffect } from "react";
import Modal from "../Modal/Modal";

function Footer() {
  const [showModal, setShowModal] = useState(false);
  const [showLegal, setShowLegal] = useState(false);

  useEffect(() => {
    if (showModal || showLegal) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showModal, showLegal]);

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleLegalClick = (e) => {
    e.preventDefault();
    setShowLegal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <footer className="footer wrapper">
      <div className="container">
        <p>
          <a href="https://www.leofrati.fr/" target="_blank" rel="noopener noreferrer">
            <strong>Leo Frati&nbsp; | &nbsp;</strong>
          </a>
          All rights reserved.
        </p>
        <ul>
          <li>
            <p onClick={handlePrivacyClick}>Privacy Policy</p>
          </li>
          <li>
            <p>·</p>
          </li>
          <li>
            <p onClick={handleLegalClick}>Legal Notice</p>
          </li>
        </ul>
      </div>
      <Modal isOpen={showModal} onClose={handleCloseModal} title="Privacy Policy">
        <p>
          Flowcam does not collect any personal data. All photos taken remain on your device and are
          never shared without your explicit consent. No information is passed on to third parties.
          If you have any questions, please contact me directly.
        </p>
      </Modal>
      <Modal isOpen={showLegal} onClose={() => setShowLegal(false)} title="Legal Notice">
        <p>
          Editor : Leo Frati <br />
          Contact : <a href="mailto:fratileo@gmail.com">fratileo@gmail.com</a> <br />
          Host : Vercel Inc, 440 N Barranca Ave #4133, Covina, CA 91723, USA <br />
        </p>
      </Modal>
    </footer>
  );
}

export default Footer;
